import colors from 'style-utils/colors';

const alertBarTheme = {
  alertBar: {
    root: {
      background: colors.messageBackgroundOrange,
      color: colors.blackTwelve,
      borderBottom: `2px solid ${colors.messageBorderOrange}`,

      maxHeight: '200px',
      width: '100%',

      mobile: { padding: '8px 16px' },
      tablet: { padding: '8px 16px' },
      desktop: { padding: '8px 16px' },
    },
    alertColumn: {
      xs: { padding: '0', minHeight: '34px' },
      mobile: { padding: '0', minHeight: '34px' },
      tablet: { padding: '0', minHeight: '34px' },
      desktop: { padding: '0', minHeight: '34px' },
    },
    container: {
      mobile: { maxWidth: '100%' },
      tablet: { maxWidth: '100%' },
      desktop: { maxWidth: '100%' },
    },
  },
};

export default alertBarTheme;
